// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"fw-z","expressButtonContainerWithPayPal":"gw-z","expressButton":"hw-z","or":"iw-z"};